import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

type SimpleEditorProps = {
  id?: string;
  value?: string;
  onChange?: (content: string) => void;
  className?: string;
};

const FONT_HEADER_LIST = ["bold", "italic", "underline"];
const ORDER_HEADER_LIST = [{ list: "ordered" }, { list: "bullet" }];

const SimpleEditor: React.FC<SimpleEditorProps> = ({
  id,
  value = "",
  className,
  onChange,
}) => {
  const [content, setContent] = useState<string>(value);

   // Sync external value -> editor state
  useEffect(() => {
    setContent(value);
  }, [value]);

  const handleChange = (newContent: string) => {
    setContent(newContent);
    onChange?.(newContent);
  };

  return (
    <ReactQuill
      id={id}
      value={content}
      onChange={handleChange}
      modules={{
        toolbar: [FONT_HEADER_LIST, ORDER_HEADER_LIST],
      }}
      formats={["bold", "italic", "underline", "list", "bullet"]}
      theme="snow"
      className={`w-100 border border-gray-300 rounded-lg editor-text ${className}`}
    />
  );
};

export default SimpleEditor;
